import { useContext } from 'react';

import type { MixpanelTrackingContextValue } from './MixpanelTrackingProvider';
import { MixpanelTrackingContext } from './MixpanelTrackingProvider';

export const useMixpanelTracking = (): MixpanelTrackingContextValue => {
    const context = useContext(MixpanelTrackingContext);

    if (context === undefined) {
        throw new Error('useMixpanelTracking must be used within MixpanelTrackingProvider');
    }

    return context;
};
